import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09d7b386"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer P-Rel" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = { class: "P1em F1_5em F-Bold" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_6 = { class: "F-Bold" }
const _hoisted_7 = {
  class: "D-Flex FlexColumn",
  style: {"gap":"1em"}
}
const _hoisted_8 = { class: "MainSection BGBlur" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "V-Auto" }
const _hoisted_11 = { class: "F-Bold V-Auto" }
const _hoisted_12 = { class: "F-Bold V-Auto O-50" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "W-Auto",
  style: {"flex":"2"}
}, null, -1))
const _hoisted_14 = { class: "V-Auto" }
const _hoisted_15 = {
  key: 0,
  class: "V-Auto"
}
const _hoisted_16 = {
  key: 1,
  class: "V-Auto"
}
const _hoisted_17 = {
  key: 1,
  class: "SectionContainer"
}
const _hoisted_18 = { class: "SectionLevel" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "F-Bold V-Auto" }
const _hoisted_21 = { class: "F-Bold V-Auto O-50" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "W-Auto",
  style: {"flex":"2"}
}, null, -1))
const _hoisted_23 = { class: "V-Auto" }
const _hoisted_24 = { class: "V-Auto" }
const _hoisted_25 = { class: "V-Auto" }
const _hoisted_26 = {
  key: 1,
  class: "SectionContainer"
}
const _hoisted_27 = { class: "SectionLevel" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "F-Bold V-Auto" }
const _hoisted_30 = { class: "F-Bold V-Auto O-50" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "W-Auto",
  style: {"flex":"2"}
}, null, -1))
const _hoisted_32 = { class: "V-Auto" }
const _hoisted_33 = {
  key: 0,
  class: "V-Auto"
}
const _hoisted_34 = {
  key: 1,
  class: "V-Auto"
}
const _hoisted_35 = {
  key: 1,
  class: "SectionContainer"
}
const _hoisted_36 = {
  class: "D-Flex",
  style: {"background":"none","justify-content":"left","gap":"1em","align-items":"center","padding-top":"0.5em"}
}
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  class: "D-Flex",
  style: {"background":"none","justify-content":"left","gap":"1em","align-items":"center","padding-top":"0.5em"}
}
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = {
  class: "D-Flex",
  style: {"background":"none","justify-content":"left","gap":"1em","align-items":"center"}
}
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = {
  key: 0,
  class: "CookiesDialogFooter"
}
const _hoisted_45 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesSearchInput = _resolveComponent("CookiesSearchInput")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesBar = _resolveComponent("CookiesBar")!
  const _component_ItemsLocations = _resolveComponent("ItemsLocations")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: 'CookiesDialog_' + _ctx.DialogIndex,
      class: "CookiesDialogdBody"
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.Saving)
          ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.Loading.length > 0)
          ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          style: _normalizeStyle([{"background-size":"20em","opacity":"0.02"}, 'background-image: url(' + _ctx.Pattern + ');']),
          class: "P-Abs Inset0 O-50"
        }, null, 4),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_ctx.Translate('Edit Warehouse Sections')), 1),
            _createTextVNode(),
            _hoisted_5,
            _createTextVNode(" ("),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.DialogData.Data.Code), 1),
            _createTextVNode(")")
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_CookiesSearchInput, {
              style: {"width":"16em","max-width":"90%"},
              Res: 'D_Warehouse_Search',
              Placeholder: _ctx.Translate('Search...')
            }, null, 8, ["Placeholder"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MainSections, (section) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", {
                  onClick: ($event: any) => (_ctx.MEMWrite('D_Warehouse_SectionContainer_' + section.ID, _ctx.MEMRead('D_Warehouse_SectionContainer_' + section.ID) ? false : true)),
                  class: "SectionTitle"
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_CookiesIcon, {
                      class: "SQR1em",
                      ID: ('Section' as IconsIDs)
                    })
                  ]),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(section.Code), 1),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(section.Name), 1),
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_CookiesIcon, {
                      class: _normalizeClass([!section.Description || section.Description === '' ? 'Disabled' : '', "SQR1em"]),
                      ToolTip: section.Description,
                      ID: ('Info' as IconsIDs)
                    }, null, 8, ["class", "ToolTip"])
                  ]),
                  (_ctx.Access('Inventory_Warehouses_Edit'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createVNode(_component_CookiesIcon, {
                          onClick: ($event: any) => (_ctx.EditSection($event, section)),
                          ToolTip: _ctx.Translate('Edit Section'),
                          class: "SQR1em HoverGlow",
                          ID: ('Edit' as IconsIDs)
                        }, null, 8, ["onClick", "ToolTip"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.Access('Inventory_Warehouses_Edit'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createVNode(_component_CookiesIcon, {
                          onClick: ($event: any) => (_ctx.RemoveSection($event, section)),
                          ToolTip: _ctx.Translate('Remove Section'),
                          class: "SQR1em HoverGlow",
                          ID: ('Delete' as IconsIDs)
                        }, null, 8, ["onClick", "ToolTip"])
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_9),
                (!_ctx.MEMRead('D_Warehouse_SectionContainer_' + section.ID))
                  ? (_openBlock(), _createBlock(_component_CookiesBar, {
                      key: 0,
                      class: "P1em",
                      Bar: _ctx.SectionCalculator(section, 'Main')
                    }, null, 8, ["Bar"]))
                  : _createCommentVNode("", true),
                (_ctx.MEMRead('D_Warehouse_SectionContainer_' + section.ID))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.LevelSections(section, 1), (Level1) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("div", {
                            onClick: ($event: any) => (_ctx.MEMWrite('D_Warehouse_SectionL1Container_' + Level1.ID, _ctx.MEMRead('D_Warehouse_SectionL1Container_' + Level1.ID) ? false : true)),
                            class: "SectionTitle"
                          }, [
                            _createElementVNode("div", _hoisted_20, _toDisplayString(Level1.Code), 1),
                            _createElementVNode("div", _hoisted_21, _toDisplayString(Level1.Name), 1),
                            _hoisted_22,
                            _createElementVNode("div", _hoisted_23, [
                              _createVNode(_component_CookiesIcon, {
                                class: _normalizeClass([!Level1.Description || Level1.Description === '' ? 'Disabled' : '', "SQR1em"]),
                                ToolTip: Level1.Description,
                                ID: ('Info' as IconsIDs)
                              }, null, 8, ["class", "ToolTip"])
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              (_ctx.Access('Inventory_Warehouses_Edit'))
                                ? (_openBlock(), _createBlock(_component_CookiesIcon, {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.EditSection($event, Level1)),
                                    ToolTip: _ctx.Translate('Edit Section'),
                                    class: "SQR1em HoverGlow",
                                    ID: ('Edit' as IconsIDs)
                                  }, null, 8, ["onClick", "ToolTip"]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              (_ctx.Access('Inventory_Warehouses_Edit'))
                                ? (_openBlock(), _createBlock(_component_CookiesIcon, {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.RemoveSection($event, Level1)),
                                    ToolTip: _ctx.Translate('Remove Section'),
                                    class: "SQR1em HoverGlow",
                                    ID: ('Delete' as IconsIDs)
                                  }, null, 8, ["onClick", "ToolTip"]))
                                : _createCommentVNode("", true)
                            ])
                          ], 8, _hoisted_19),
                          (!_ctx.MEMRead('D_Warehouse_SectionL1Container_' + Level1.ID))
                            ? (_openBlock(), _createBlock(_component_CookiesBar, {
                                key: 0,
                                class: "P1em",
                                Bar: _ctx.SectionCalculator(Level1, 'Level1')
                              }, null, 8, ["Bar"]))
                            : _createCommentVNode("", true),
                          (_ctx.MEMRead('D_Warehouse_SectionL1Container_' + Level1.ID))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.LevelSections(Level1, 2), (Level2) => {
                                  return (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    _createElementVNode("div", {
                                      onClick: ($event: any) => (_ctx.MEMWrite('D_Warehouse_SectionL2Container_' + Level2.ID, _ctx.MEMRead('D_Warehouse_SectionL2Container_' + Level2.ID) ? false : true)),
                                      class: "SectionTitle"
                                    }, [
                                      _createElementVNode("div", _hoisted_29, _toDisplayString(Level2.Code), 1),
                                      _createElementVNode("div", _hoisted_30, _toDisplayString(Level2.Name), 1),
                                      _hoisted_31,
                                      _createElementVNode("div", _hoisted_32, [
                                        _createVNode(_component_CookiesIcon, {
                                          class: _normalizeClass([!Level2.Description || Level2.Description === '' ? 'Disabled' : '', "SQR1em"]),
                                          ToolTip: Level2.Description,
                                          ID: ('Info' as IconsIDs)
                                        }, null, 8, ["class", "ToolTip"])
                                      ]),
                                      (_ctx.Access('Inventory_Warehouses_Edit'))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                            _createVNode(_component_CookiesIcon, {
                                              onClick: ($event: any) => (_ctx.EditSection($event, Level2)),
                                              ToolTip: _ctx.Translate('Edit Section'),
                                              class: "SQR1em HoverGlow",
                                              ID: ('Edit' as IconsIDs)
                                            }, null, 8, ["onClick", "ToolTip"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.Access('Inventory_Warehouses_Edit'))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                            _createVNode(_component_CookiesIcon, {
                                              onClick: ($event: any) => (_ctx.RemoveSection($event, Level2)),
                                              ToolTip: _ctx.Translate('Remove Section'),
                                              class: "SQR1em HoverGlow",
                                              ID: ('Delete' as IconsIDs)
                                            }, null, 8, ["onClick", "ToolTip"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 8, _hoisted_28),
                                    (!_ctx.MEMRead('D_Warehouse_SectionL2Container_' + Level2.ID))
                                      ? (_openBlock(), _createBlock(_component_CookiesBar, {
                                          key: 0,
                                          class: "P1em",
                                          Bar: _ctx.SectionCalculator(Level2, 'Level2')
                                        }, null, 8, ["Bar"]))
                                      : _createCommentVNode("", true),
                                    (_ctx.MEMRead('D_Warehouse_SectionL2Container_' + Level2.ID))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                          _createVNode(_component_ItemsLocations, {
                                            Res: 'ItemsLocations_2',
                                            SectionID: Level2.ID,
                                            SectionVolume: Level2.Volume,
                                            ItemsLocations: _ctx.FilteredItemsLocations
                                          }, null, 8, ["SectionID", "SectionVolume", "ItemsLocations"]),
                                          _createElementVNode("div", _hoisted_36, [
                                            (_ctx.Access('Inventory_Warehouses_Edit'))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                                  _createVNode(_component_CookiesIcon, {
                                                    onClick: ($event: any) => (_ctx.AddItem(Level2)),
                                                    class: "SQR1_5em HoverGlow Shadow2",
                                                    ToolTip: _ctx.Translate('Add Items'),
                                                    ID: ('AddItem' as IconsIDs)
                                                  }, null, 8, ["onClick", "ToolTip"])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 256)),
                                _createVNode(_component_ItemsLocations, {
                                  Res: 'ItemsLocations_1_' + Level1.ID,
                                  SectionID: Level1.ID,
                                  SectionVolume: Level1.Volume,
                                  ItemsLocations: _ctx.FilteredItemsLocations
                                }, null, 8, ["Res", "SectionID", "SectionVolume", "ItemsLocations"]),
                                _createElementVNode("div", _hoisted_38, [
                                  (_ctx.Access('Inventory_Warehouses_Edit'))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                        (!_ctx.MEMRead('ItemsLocations_1_' + Level1.ID) || (_ctx.MEMRead('ItemsLocations_1_' + Level1.ID) && _ctx.MEMRead('ItemsLocations_1_' + Level1.ID).length === 0))
                                          ? (_openBlock(), _createBlock(_component_CookiesIcon, {
                                              key: 0,
                                              onClick: ($event: any) => (_ctx.AddSection({ Level1: section,  Level2: Level1 })),
                                              class: "SQR1_5em HoverGlow Shadow2",
                                              ToolTip: _ctx.Translate('Add Section'),
                                              ID: ('Add' as IconsIDs)
                                            }, null, 8, ["onClick", "ToolTip"]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.Access('Inventory_Warehouses_Edit'))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                        (_ctx.LevelSections(Level1, 2).length === 0)
                                          ? (_openBlock(), _createBlock(_component_CookiesIcon, {
                                              key: 0,
                                              onClick: ($event: any) => (_ctx.AddItem(Level1)),
                                              class: "SQR1_5em HoverGlow Shadow2",
                                              ToolTip: _ctx.Translate('Add Items'),
                                              ID: ('AddItem' as IconsIDs)
                                            }, null, 8, ["onClick", "ToolTip"]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 256)),
                      _createVNode(_component_ItemsLocations, {
                        Res: 'ItemsLocations_Main_' + section.ID,
                        SectionID: section.ID,
                        SectionVolume: section.Volume,
                        ItemsLocations: _ctx.FilteredItemsLocations
                      }, null, 8, ["Res", "SectionID", "SectionVolume", "ItemsLocations"]),
                      _createElementVNode("div", _hoisted_41, [
                        (_ctx.Access('Inventory_Warehouses_Edit'))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                              (!_ctx.MEMRead('ItemsLocations_Main_' + section.ID) || (_ctx.MEMRead('ItemsLocations_Main_' + section.ID) && _ctx.MEMRead('ItemsLocations_Main_' + section.ID).length === 0))
                                ? (_openBlock(), _createBlock(_component_CookiesIcon, {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.AddSection({ Level1: section })),
                                    class: "SQR1_5em HoverGlow Shadow2",
                                    ToolTip: _ctx.Translate('Add Section'),
                                    ID: ('Add' as IconsIDs)
                                  }, null, 8, ["onClick", "ToolTip"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.Access('Inventory_Warehouses_Edit'))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                              (_ctx.LevelSections(section, 1).length === 0)
                                ? (_openBlock(), _createBlock(_component_CookiesIcon, {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.AddItem(section)),
                                    class: "SQR1_5em HoverGlow Shadow2",
                                    ToolTip: _ctx.Translate('Add Items'),
                                    ID: ('AddItem' as IconsIDs)
                                  }, null, 8, ["onClick", "ToolTip"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 256))
          ]),
          (_ctx.Access('Inventory_Warehouses_Edit'))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.AddSection({}))),
                class: _normalizeClass([_ctx.Sections.length === 0 ? 'F2em' : 'F1_5em', "W-100 D-Flex"]),
                style: {"padding":"1em 0em"}
              }, [
                _createVNode(_component_CookiesIcon, {
                  class: "SQR2em M-Auto HoverGlow",
                  ToolTip: _ctx.Translate('Add Section'),
                  ID: ('Add' as IconsIDs)
                }, null, 8, ["ToolTip"])
              ], 2))
            : _createCommentVNode("", true)
        ])
      ])
    ], 8, _hoisted_1),
    (_ctx.Access(_ctx.DialogData.Editing ? 'Catalogue_Edit': 'Catalogue_Create'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1))),
              style: {"background":"var(--colorr1)"},
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Close')), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}